import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from "react";
export function SVGNewsletter(props) {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M82.899,52.35236H82.9a2.12479,2.12479,0,0,0,2.12573-2.12372l0.01367-37.24512a4.25992,4.25992,0,0,0-4.30322-4.47961l-76.41681.001A4.08454,4.08454,0,0,0,.76361,10.4231,4.95494,4.95494,0,0,0,0,12.986c0.002,1.49219.04395,36.6698,0.01514,47.65509A4.57928,4.57928,0,0,0,1.35,63.91443a4.31048,4.31048,0,0,0,3.0675,1.28235l78.43756-.0097a2.12466,2.12466,0,1,0,0-4.24933L4.35986,60.91339a0.35889,0.35889,0,0,1-.09326-0.26062C4.29224,50.86,4.26178,21.89417,4.25305,14.639L41.43994,36.55621a2.12709,2.12709,0,0,0,2.15869,0L80.78729,14.639,80.77423,50.22668A2.125,2.125,0,0,0,82.899,52.35236Zm-40.37946-20.092L9.42291,12.75409,75.618,12.75323Z" fill="currentColor" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg aria-hidden="true" version="1.1" viewBox="0 0 85.04 75.04" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}